import ChevronLeftIcon from '@mui/icons-material/ChevronLeftRounded';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Card, IconButton, Typography } from '@mui/material';
import { ShowView, useGetIdentity, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';

import { ExternalLink, useDefineAppLocation } from '@sh4res/bo-common/components';
import { PageTitle } from '@sh4res/bo-common/components/PageTitle';
import { isB2bDistributor } from '@sh4res/bo-common/utils/b2b_auth_role';

import { DistributorEmails } from '@Components/ContactSupport/DistributorEmails';
import { styles } from '@Components/ContactSupport/styles';
import { ContactRequestShow } from '@Resources/contact_request/ContactRequestShow';

export const ContactSupport = () => {
  useDefineAppLocation('contact_support');
  const navigate = useNavigate();
  const translate = useTranslate();
  const { data: identity } = useGetIdentity();

  const translatedTitle = translate('contact_support_page.title');

  const title = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        data-testid={'BoExternalContactSupport_BackButton'}
        onClick={() => navigate(-1)}
        edge="start"
        aria-label={translate('contact_support_page.accessibility.back')}
        sx={{ height: '26px', color: 'black', backgroundColor: 'transparent !important;' }}>
        <ChevronLeftIcon sx={{ fontSize: '23px', marginTop: '10px' }} />
      </IconButton>
      <Typography variant="h1" sx={{ fontSize: '17px', fontWeight: 600, paddingTop: '10px' }}>
        {translatedTitle}
      </Typography>
    </Box>
  );

  const isDistributor = isB2bDistributor(identity);

  return (
    <>
      <PageTitle title={translatedTitle} />
      <ShowView title={title} component={Box}>
        <Card sx={styles.section}>
          <Box sx={styles.header}>
            <PhoneIcon />
            <Box>{translate('contact_support_page.sections.phone.title')}</Box>
          </Box>
          <Box sx={styles.grid}>
            <Box sx={styles.rowCell}>
              <Typography>{translate('contact_support_page.sections.phone.number')}</Typography>
            </Box>
            <Box sx={styles.rowCell}>
              {translate('contact_support_page.sections.phone.phone_number')}
            </Box>
            <Box sx={styles.rowCell}>
              {translate('contact_support_page.sections.phone.opening_time')}
            </Box>
            <Box sx={styles.rowCell}>
              {translate('contact_support_page.sections.phone.opening_time_value')}
            </Box>
          </Box>
        </Card>

        <Card sx={styles.section}>
          <Box sx={styles.header}>
            <EventIcon />
            <Box>{translate('contact_support_page.sections.appointment.title')}</Box>
          </Box>
          <Box sx={styles.grid}>
            <Box sx={styles.rowCell}>
              <Typography>
                {translate('contact_support_page.sections.appointment.axa_epargne_entreprise')}
              </Typography>
            </Box>
            <Box sx={styles.rowCell}>
              <ExternalLink
                href="https://proxy.greenbureau.com/axa_ere_public_web/zcare/113/?gb-skill=sLDm3ahBATHzcAW8EsREe5"
                sx={{ textDecoration: 'none', color: 'primary.main' }}>
                {translate('contact_support_page.sections.appointment.standard_contract_link')}
              </ExternalLink>
            </Box>
            {isDistributor && (
              <>
                <Box sx={styles.rowCell}>
                  <Typography>
                    {translate('contact_support_page.sections.appointment.new_business')}
                  </Typography>
                </Box>
                <Box sx={styles.rowCell}>
                  <ExternalLink
                    href="https://bit.ly/afnouvelles"
                    sx={{ textDecoration: 'none', color: 'primary.main' }}>
                    {translate('contact_support_page.sections.appointment.new_business_link')}
                  </ExternalLink>
                </Box>
              </>
            )}
          </Box>
        </Card>

        <Card sx={styles.section}>
          <Box sx={styles.header}>
            <EmailIcon />
            <Box>{translate('contact_support_page.sections.email.title')}</Box>
          </Box>
          {isDistributor ? (
            <DistributorEmails />
          ) : (
            <Box sx={styles.grid}>
              <Box sx={styles.rowCell}>
                <Typography>{translate('contact_support_page.sections.email.label')}</Typography>
              </Box>
              <Box sx={styles.rowCell}>
                <ContactRequestShow />
              </Box>
            </Box>
          )}
        </Card>
      </ShowView>
    </>
  );
};
